import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { MenuSection } from '../../../../../common/types.tsx';
import { CONTEXT_MENU_SECTION_TESTID } from './constants.tsx';

type Props = {
	section: MenuSection;
	children: ReactNode;
};

export const ContextMenuSection = ({ section, children }: Props) => (
	<div data-testid={CONTEXT_MENU_SECTION_TESTID}>
		<ContextMenuSectionLabel>{section.label}</ContextMenuSectionLabel>
		{children}
	</div>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContextMenuSectionLabel = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N200),
	paddingTop: token('space.050', '4px'),
	paddingRight: token('space.100', '8px'),
	paddingBottom: token('space.050', '4px'),
	paddingLeft: token('space.100', '8px'),
	font: token('font.body.small'),
	textTransform: 'uppercase',
});
